import React from "react";
import {translationStore} from "../../../store/translationStore";
import "./index.scss";
import {observer} from "mobx-react-lite";
import {authStore} from "../../../store/authStore";

const Footer = observer(() => {
    const {translationData} = translationStore;
    const {setTermsPopup} = authStore;
    return (
        <div className="registration-footer-container">
            <span onClick={() => setTermsPopup("terms")} className="registration-footer-el">{translationData?.["terms_of_use"]}</span>
            <span onClick={() => setTermsPopup("cookie")} className="registration-footer-el">{translationData?.["cookies_policy"]}</span>
            <span onClick={() => setTermsPopup("privacy")} className="registration-footer-el">{translationData?.["privacy_policy"]}</span>
        </div>
    )
});

export default Footer;